import { useTranslations } from 'next-intl';
import { toRoman } from './utils';

const getRank = (rank: number, t: ReturnType<typeof useTranslations>) => {
  const key = `results_rank_${rank}`;
  const hasLotterySpecificRank = t.has(key);
  return hasLotterySpecificRank ? t(key) : toRoman(rank);
};

const useGetRank = (namespace: string) => {
  const t = useTranslations(namespace);
  return (rank: number) => getRank(rank, t);
};

export { useGetRank };
